module.exports = __webpack_public_path__ + "img/help-icon2.e72b938f.png";